import type { FaireProductEntity } from "../../entity_types/product";

export const p_5e2kbarykm: FaireProductEntity = {
  token: "p_5e2kbarykm",
  type: "product",
  name: "SUMMER BEACH PUKA SHELL NECKLACE | 80N661",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/bc2d045320aecf8c95f8aac746d03b41e66543058e6ed11d54c5962e668392bf.jpeg",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/dbb2d5f306d4ab9f34fa35679d4e69c85581b80f7eb9b658d1434ad6b8123183.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
